import Vue from 'vue';
import App from './App';
import router from './router';
import animated from 'animate.css'; 
import iView from 'iview/dist/iview.js';
import showToast from './components/toast';
Vue.use(animated);
Vue.use(iView);
Vue.use(showToast);

Vue.prototype.$Message.config({
    top: 300,
    duration: 2
});

Vue.config.productionTip = false;

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js